var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShipping = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "shipping_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M34.862 19.318a1 1 0 0 0-1 1v5.519a1 1 0 0 0 1 1h6.436a1 1 0 0 0 1-1v-2.52a4 4 0 0 0-4-4zm.25 1.25v5.019h5.936v-2.27a2.75 2.75 0 0 0-2.75-2.75z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m16.142 33.632.001.127a4.617 4.617 0 1 1-9.232-.127H4.578a2 2 0 0 1-2-2V11.624a2 2 0 0 1 2-2h25.321a2 2 0 0 1 2 2v4.462h7.523a6 6 0 0 1 6 6v9.546a2 2 0 0 1-2 2h-3.545l.001.127a4.617 4.617 0 1 1-9.232-.127zm13.757-22.758H4.578a.75.75 0 0 0-.75.75v20.008c0 .414.336.75.75.75h2.54a4.619 4.619 0 0 1 8.816 0H30.65V11.624a.75.75 0 0 0-.75-.75m1.996 22.885a3.367 3.367 0 1 0 6.733 0 3.367 3.367 0 0 0-6.733 0m.006-16.423h7.521a4.75 4.75 0 0 1 4.75 4.75v9.546a.75.75 0 0 1-.75.75H39.67a4.62 4.62 0 0 0-7.768-1.789zM14.893 33.759a3.367 3.367 0 1 1-6.733 0 3.367 3.367 0 0 1 6.733 0",
  clipRule: "evenodd"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeMiterlimit: 10,
  strokeWidth: 2.5,
  d: "M34.862 19.318a1 1 0 0 0-1 1v5.519a1 1 0 0 0 1 1h6.436a1 1 0 0 0 1-1v-2.52a4 4 0 0 0-4-4zm.25 1.25v5.019h5.936v-2.27a2.75 2.75 0 0 0-2.75-2.75z",
  clipRule: "evenodd",
  mask: "url(#shipping_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeMiterlimit: 10,
  strokeWidth: 2.5,
  d: "m16.142 33.632.001.127a4.617 4.617 0 1 1-9.232-.127H4.578a2 2 0 0 1-2-2V11.624a2 2 0 0 1 2-2h25.321a2 2 0 0 1 2 2v4.462h7.523a6 6 0 0 1 6 6v9.546a2 2 0 0 1-2 2h-3.545l.001.127a4.617 4.617 0 1 1-9.232-.127zm13.757-22.758H4.578a.75.75 0 0 0-.75.75v20.008c0 .414.336.75.75.75h2.54a4.619 4.619 0 0 1 8.816 0H30.65V11.624a.75.75 0 0 0-.75-.75Zm1.996 22.885a3.367 3.367 0 1 0 6.733 0 3.367 3.367 0 0 0-6.733 0Zm.006-16.423h7.521a4.75 4.75 0 0 1 4.75 4.75v9.546a.75.75 0 0 1-.75.75H39.67a4.62 4.62 0 0 0-7.768-1.789zM14.893 33.759a3.367 3.367 0 1 1-6.733 0 3.367 3.367 0 0 1 6.733 0Z",
  clipRule: "evenodd",
  mask: "url(#shipping_svg__a)"
})));
export { SvgShipping as ReactComponent };